import { Component, Input, OnInit } from '@angular/core'

import { AssistanceStatus } from '../../../models/assistanceStatus'

@Component({
  selector: 'app-assistance-status',
  standalone: true,
  imports: [],
  templateUrl: './assistance-status.component.html',
  styleUrls: ['./assistance-status.component.scss'],
})
export class AssistanceStatusComponent implements OnInit {
  @Input() status: AssistanceStatus

  constructor() {}

  ngOnInit() {}
}
